import {FC, Fragment, memo} from "react";
import {SectionTabsProps} from "./SectionTabs-types";
import LinkButton from "../LinkButton/LinkButton";
import {Body, Foot, Head, Root} from "./SectionTabs-styles";
import SectionVariants from "../SectionVariants/SectionVariants";
import {useActiveGroup, useActiveOptions} from "./SectionTabs-hooks";
import TooltipForSection from "../TooltipForSection/TooltipForSection";
import {generateUid} from "../../utils/ApplicationUtils";

const SectionTabs: FC<SectionTabsProps> = memo((props) => {
    const {uid, groups, options, onOptionSelect} = props;

    const {activeGroup, onActiveGroupChange} = useActiveGroup(groups, uid);
    const {activeOptions} = useActiveOptions(options, activeGroup?.id);

    return (
        <Root>
            <Head>
                {
                    (groups || []).map((group) => (
                        <LinkButton
                            key={group.id}
                            value={group.id}
                            text={group.title}
                            isActive={group.id === activeGroup?.id}
                            onClick={onActiveGroupChange}/>
                    ))
                }
            </Head>

            <Body>
                <SectionVariants uid={uid} options={activeOptions} onOptionSelect={onOptionSelect}/>

                {
                    activeGroup?.caption &&
                    <TooltipForSection
                        uid={generateUid(uid, activeGroup.id)}
                        text={activeGroup.caption.title}
                        image={activeGroup.caption.image}/>
                }
            </Body>

            <Foot>
                {options.map((option) => (
                    <Fragment key={option.id}>
                        <img src={option.imagePreview} alt=""/>
                        <img src={option.imageFill} alt=""/>
                    </Fragment>
                ))}
            </Foot>
        </Root>
    )
});

export default SectionTabs;
